/**
 * Created by comoon on 3/7/16.
 */

var React = require('react');

var QuoteApplyForm = require("./QuoteApplyForm");

var ALikeStore = require("../store/ALikeStore");

var {ElementConstants, EventConstants} = require("../Constants");

var QuoteStatus = require("../conf/quote-status");

var ReactDOM = require("react-dom");

var $ = require("jquery");

module.exports = React.createClass({
    displayName: "QuoteApplyFormWrapper",

    getInitialState(){

        return {
            quote: null
        }
    },

    componentWillMount(){

        ALikeStore.on(EventConstants.ACTION_TWEAK_QUOTE_START, this.on_tweakQuoteStart);
    },
    componentWillUnmount(){

        ALikeStore.off(EventConstants.ACTION_TWEAK_QUOTE_START, this.on_tweakQuoteStart);
    },

    componentDidUpdate(){

        var ele = ReactDOM.findDOMNode(this);

        var top = $(ele).offset().top - $(ElementConstants.TOP_NAV_CLASS).height();

        $(window).scrollTop(top);
    },

    on_tweakQuoteStart(){
        this.setState({
            quote: ALikeStore.get_recordDetail(ALikeStore.get_currentRecord())
        });
    },

    render(){

        var expired = false;

        if (this.state.quote && this.state.quote.isExpired) {

            expired = true;
        }

        return (<QuoteApplyForm formData={this.state.quote} expired={expired}/>);
    }
});
 


/** WEBPACK FOOTER **
 ** ./script/detail-m/QuoteApplyFormWrapper.jsx
 **/